export default {
	'delete-unit': 'Birimi sil ',
	unit: 'Birim'
}